import api from './client';
import { queryClient } from '../../lib/queryClient';

// ─── Types ───────────────────────────────────────────────────────────────────

export interface TemplateSection {
  title: string;
  topics: string[];
}

export interface NegotiationTemplate {
  id: number;
  publicId: string;
  title: string;
  description: string | null;
  dynamicType: string;
  isSystem: boolean;
  createdBy: number | null;
  organizationId: number | null;
  sections: TemplateSection[];
  safetyNotes: string | null;
  isActive: boolean;
  timesUsed: number;
  createdAt: string;
}

export interface CreateTemplateData {
  title: string;
  description?: string;
  dynamicType: string;
  sections: TemplateSection[];
  safetyNotes?: string;
}

// ─── API ─────────────────────────────────────────────────────────────────────

export const negotiationTemplateAPI = {
  /** List all templates (system + org custom) */
  getTemplates: () =>
    api.get<{ success: boolean; data: NegotiationTemplate[] }>('/negotiation-templates'),

  /** Get a single template by public ID */
  getTemplate: (publicId: string) =>
    api.get<{ success: boolean; data: NegotiationTemplate }>(`/negotiation-templates/${publicId}`),

  /** Create a custom template for the current Hierarchy */
  createCustomTemplate: async (orgPublicId: string, data: CreateTemplateData) => {
    const result = await api.post<{ success: boolean; data: NegotiationTemplate }>(
      `/organizations/${orgPublicId}/negotiation-templates`,
      data
    );
    queryClient.invalidateQueries({ queryKey: ['negotiation-templates'] });
    return result;
  },

  /** Update an existing custom template */
  updateCustomTemplate: async (orgPublicId: string, publicId: string, data: CreateTemplateData) => {
    const result = await api.put<{ success: boolean; data: NegotiationTemplate }>(
      `/organizations/${orgPublicId}/negotiation-templates/${publicId}`,
      data
    );
    queryClient.invalidateQueries({ queryKey: ['negotiation-templates'] });
    return result;
  },

  /** Mark a template as used and return its data for pre-populating */
  useTemplate: (publicId: string) =>
    api.post<{ success: boolean; data: NegotiationTemplate }>(
      `/negotiation-templates/${publicId}/use`
    ),
};
